//----- Component --------------------------------------------------------/
// Developer :  Ignacio Bastianelli
// Creation Date :28/01/2025
// Version : 1.0
// Description : CRUD tabla facturas
//------Changes ----------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/

import React, { useState, useMemo, useEffect } from "react";
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es"; //Tabla en español
import Navbar from "../../Navbar";
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import EditNoteIcon from "@mui/icons-material/EditNote";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {
  Button,
  Container,
  Alert,
  Box,
  Typography,
  ListItemIcon,
  MenuItem,
} from "@mui/material";
import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import { getData } from "../../../services/library";
import FacturasForm from "./FacturasFrom";
import FacturasDelete from "./FacturasDelete";
import { logEventos } from "../../../services/services";

const Facturas = () => {
  const [facturas, setFacturas] = useState([]);
  const [openModalForm, setOpenModalForm] = useState(false);
  const [openUpdateStatusModal, setOpenUpdateStatusModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [rowInfo, setRowInfo] = useState({});
  const [mostrarAlerta, setMostrarAlerta] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [rowInfoToUpdateStatus, setRowInfoToUpdateStatus] = useState({});
  //
  const getFacturas = () => {
    getData("/facturasParametros", setFacturas);
  };

  useEffect(() => {
    getFacturas();
  }, []);

  const handleOpenCloseForm = () => {
    setOpenModalForm(!openModalForm);
  };

  const handleOpenUpdateStatus = () => {
    setOpenUpdateStatusModal(true);
  };

  const mostrarAlertaTemporal = (mensaje, severidad) => {
    setMostrarAlerta(true);
    setMessage(mensaje);
    setSeverity(severidad);

    setTimeout(() => {
      setMostrarAlerta(false);
    }, 5000);
  };

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 10 },
  };

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "primary",
    size: "small",
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  const columns = useMemo(
    () => [
      { header: "ID", accessorKey: "id", size: 10 },
      { header: "Parametro", accessorKey: "parametro", size: 60 },
      { header: "Valor", accessorKey: "valor", size: 40 },
      { header: "Descripcion", accessorKey: "descripcion", size: 200 },
    ],
    []
  );

  const globalTheme = useTheme();
  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode,
          primary: globalTheme.palette.primary,
          info: {
            main: "rgb(255,122,0)",
          },
          background: {
            default:
              globalTheme.palette.mode === "light"
                ? "rgb(234, 239, 241)"
                : "#000",
          },
        },
        typography: {
          button: {
            textTransform: "none",
            fontSize: "1rem",
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "0.8rem",
              },
            },
          },
        },
      }),
    [globalTheme]
  );

  useEffect(() => {
  logEventos(
    "acceso al menú  Facturas Parametros",
   "Tablas Referencias",
    "Facturas Parametros", 
    localStorage.getItem("user"));
}, []);

  return (
    <>
      {openModalForm && (
        <FacturasForm
          rowInfo={isEditMode ? rowInfo : {}}
          handleOpenCloseModalForm={handleOpenCloseForm}
          obtenerFacturas={getFacturas}
          mostrarAlertaTemporal={mostrarAlertaTemporal}
          isEditMode={isEditMode}
        />
      )}
      {openUpdateStatusModal && (
        <FacturasDelete
          id={rowInfoToUpdateStatus.id}
          activa={rowInfoToUpdateStatus.activo}
          open={openUpdateStatusModal}
          setOpen={setOpenUpdateStatusModal}
          mostrarAlerta={mostrarAlertaTemporal}
          getFacturas={getFacturas}
        />
      )}
      {mostrarAlerta && (
        <Alert
          severity={severity}
          sx={{
            zIndex: 1600,
            position: "fixed",
            top: "20px",
            right: "20px",
            width: "auto",
            borderRadius: "8px",
            backgroundColor:
              severity === "success"
                ? "#d8e6d3"
                : severity === "error"
                ? "#efc3c3"
                : severity === "warning"
                ? "#f0efb6"
                : "#e6e6e6",
          }}
        >
          {message}
        </Alert>
      )}
      <Navbar />
      <Container maxWidth="xl" mt={1}>
        {facturas ? (
          <Box mt={2} mb={4}>
            <ThemeProvider theme={tableTheme}>
              <MaterialReactTable
                enableToolbarInternalActions={true}
                enableGrouping
                layoutMode="grid"
                muiTableHeadCellProps={tableHeadCellProps}
                muiTableBodyCellProps={({ row }) => ({
                  align: "left",
                  sx: {
                    color: "black",
                    borderColor: "black",
                    backgroundColor: row.original.activo
                      ? "#b3e6b3"
                      : "#efc3c3",
                    wordWrap: "break-word", // Permite que el texto se divida cuando sea necesario
                    whiteSpace: "normal", // Permite que el texto ocupe varias líneas
                  },
                })}
                enableColumnActions={true}
                enableColumnFilters={false}
                enableHiding={false}
                enableDensityToggle={false}
                localization={MRT_Localization_ES}
                enableColumnDragging={false}
                initialState={initialState}
                // renderDetailPanel={renderDetailPanel}
                muiSearchTextFieldProps={muiSearchTextFieldProps}
                columns={columns}
                data={facturas}
                enableStickyFooter
                enableRowActions
                positionActionsColumn="last"
                renderToolbarInternalActions={({ table }) => <></>}
                renderTopToolbarCustomActions={() => (
                  <Box sx={{ display: "flex" }}>
                    <Box
                      sx={{
                        marginRight: 2,
                      }}
                    >
                      <Button
                        variant="contained"
                        color="success"
                        startIcon={<AddBoxTwoToneIcon color="asd" />}
                        aria-haspopup="true"
                        onClick={() => {
                          setIsEditMode(false);
                          handleOpenCloseForm();
                        }}
                      >
                        Añadir Factura
                      </Button>
                    </Box>
                    <Typography
                      variant="poster"
                      style={{ fontSize: 26, textAlign: "center" }}
                    >
                      Facturas
                    </Typography>
                  </Box>
                )}
                renderRowActionMenuItems={({ closeMenu, row }) => (
                  <Box>
                    <MenuItem
                      onClick={() => {
                        setIsEditMode(true);
                        setRowInfo(row.original);
                        closeMenu();
                        handleOpenCloseForm();
                      }}
                    >
                      <ListItemIcon>
                        <EditNoteIcon sx={{ color: "skyblue" }} />
                      </ListItemIcon>
                      Editar
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        handleOpenUpdateStatus();
                        setRowInfoToUpdateStatus({
                          id: row.original.id,
                          activo: row.original.activo,
                        });
                        closeMenu();
                      }}
                    >
                      <ListItemIcon>
                        {row.original.activo ? (
                          <HighlightOffIcon color="error" />
                        ) : (
                          <CheckCircleIcon color="success" />
                        )}
                      </ListItemIcon>
                      {row.original.activo
                        ? "Marcar como inactivo"
                        : "Marcar como activo"}
                    </MenuItem>
                  </Box>
                )}
              />
            </ThemeProvider>
          </Box>
        ) : null}
      </Container>
    </>
  );
};

export default Facturas;
